module.exports = __webpack_public_path__ + "img/formulastudent.9b7b017d.webp";